import React from 'react'
import { useLocation } from 'react-router-dom'

export interface IParamsUrl {
    [key: string]: string
}

export default function getQueryParams(): IParamsUrl | undefined {
    const query = new URLSearchParams(useLocation().search)
    const [params, setParams] = React.useState<IParamsUrl>()

    async function setParamsUrl(): Promise<void> {
        const paramsUrl: IParamsUrl = {}
        for await (const [key, value] of query.entries()) {
            paramsUrl[key] = value
        }
        setParams(paramsUrl)
    }

    React.useEffect(() => {
        setParamsUrl()
    }, [useLocation().search])

    return params
}
export function getQueryParamsInLine(): IParamsUrl {
    const urlParams = new URLSearchParams(window.location.search)

    const paramsUrl: IParamsUrl = {}
    for (const [key, value] of urlParams.entries()) {
        paramsUrl[key] = value
    }

    return paramsUrl
}
